import { render, staticRenderFns } from "./PageFileOption.vue?vue&type=template&id=eb49c1ea"
import script from "./PageFileOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageFileOption.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports